"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GA3ECommerceEventType = void 0;
var GA3ECommerceEventType;
(function (GA3ECommerceEventType) {
    GA3ECommerceEventType["AddPaymentInfo"] = "add_payment_info";
    GA3ECommerceEventType["AddShippingInfo"] = "add_shipping_info";
    GA3ECommerceEventType["AddToWishList"] = "add_to_wishlist";
    GA3ECommerceEventType["AddToCart"] = "add_to_cart";
    GA3ECommerceEventType["BeginCheckout"] = "begin_checkout";
    GA3ECommerceEventType["Purchase"] = "purchase";
    GA3ECommerceEventType["Refund"] = "refund";
    GA3ECommerceEventType["RemoveFromCart"] = "remove_from_cart";
    GA3ECommerceEventType["SelectItem"] = "select_item";
    GA3ECommerceEventType["SelectPromotion"] = "select_promotion";
    GA3ECommerceEventType["ViewCart"] = "view_cart";
    GA3ECommerceEventType["ViewItem"] = "view_item";
    GA3ECommerceEventType["ViewItemList"] = "view_item_list";
    GA3ECommerceEventType["ViewPromotion"] = "view_promotion";
})(GA3ECommerceEventType = exports.GA3ECommerceEventType || (exports.GA3ECommerceEventType = {}));
//# sourceMappingURL=ga3.service.interface.js.map